import { render, staticRenderFns } from "./data-import-status.vue?vue&type=template&id=5bb806fe&scoped=true&"
import script from "./data-import-status.vue?vue&type=script&lang=ts&"
export * from "./data-import-status.vue?vue&type=script&lang=ts&"
import style0 from "./data-import-status.vue?vue&type=style&index=0&id=5bb806fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb806fe",
  null
  
)

export default component.exports